/**
 * Application Configuration
 */

// API Base URL - switch between local dev and production
// In production, use empty string for same-origin (relative URLs)
const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'development' 
    ? 'http://localhost:8787' 
    : ''
);

export { API_BASE_URL };
